import FacebookOutlined from '@mui/icons-material/FacebookOutlined'
import Instagram from '@mui/icons-material/Instagram'
import LinkedIn from '@mui/icons-material/LinkedIn'
import YouTube from '@mui/icons-material/YouTube'
import type { ParseKeys } from 'i18next'
import type { JSX } from 'react'

export type CareerSocialKey =
  | 'facebookLink'
  | 'instagramLink'
  | 'linkedinLink'
  | 'youtubeLink'

export type CareerSocialNetwork = {
  brandName: 'facebook' | 'instagram' | 'linkedin' | 'youtube'
  label: ParseKeys<'network.career_website'>
  renderIcon: () => JSX.Element
}

export const careerSocialNetworks: Record<
  CareerSocialKey,
  CareerSocialNetwork
> = {
  facebookLink: {
    brandName: 'facebook',
    label: 'contact.social_networks.input.facebook_label',
    renderIcon: () => <FacebookOutlined htmlColor="#082ADA" />,
  },
  instagramLink: {
    brandName: 'instagram',
    label: 'contact.social_networks.input.instagram_label',
    renderIcon: () => <Instagram htmlColor="#CF3692" />,
  },
  linkedinLink: {
    brandName: 'linkedin',
    label: 'contact.social_networks.input.linkedin_label',
    renderIcon: () => <LinkedIn htmlColor="#3248BE" />,
  },
  youtubeLink: {
    brandName: 'youtube',
    label: 'contact.social_networks.input.youtube_label',
    renderIcon: () => <YouTube htmlColor="#FF0000" />,
  },
}
